import { ofType } from 'redux-observable';
import { ignoreElements } from 'rxjs/operators/ignoreElements';
import { tap } from 'rxjs/operators/tap';

import { types as actions } from '../../reducers/actions';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.SET_CURRENT_SITE),
    tap(
      action =>
        action.save &&
        localStorage.setItem(`airfinder_selected_site`, action.site.id)
    ),
    ignoreElements()
  );
}



// WEBPACK FOOTER //
// ./src/epics/sites/setCurrentSite.js